import { captureException } from "@sentry/browser";

import type { GetCurrentUserDashboardsQuery } from "generated/graphql";
import { generateApolloClientInstance, isAuthTokenRejectedError } from "settings/apollo";
import { getIdToken, logout } from "settings/auth0";

import GET_CURRENT_USER_DASHBOARDS_QUERY from "./graphql/getCurrentUserDashboards";

export type TDashboardsLoaderResponse = { currentUser: GetCurrentUserDashboardsQuery["currentUser"] };

export const dashboardsLoader = async (): Promise<TDashboardsLoaderResponse> => {
  const apolloClient = generateApolloClientInstance(getIdToken, logout);

  try {
    const {
      data: { currentUser },
    } = await apolloClient.query<GetCurrentUserDashboardsQuery>({ query: GET_CURRENT_USER_DASHBOARDS_QUERY });

    return { currentUser };
  } catch (error) {
    captureException(error);

    if (isAuthTokenRejectedError(error)) {
      await logout();
    }

    return { currentUser: null };
  }
};
